<div class="container">
  <h2>QBuilt Support</h2>

  <section class="delete-inspection-section">
    <h3>Clear an In-Progress Inspection from Selected Zone</h3>
    <p class="hint">
      Use this to remove an inspection that is currently in progress in QBuilt. Select a plant, zone,
      and serial number — the home will be cleared from the active inspections page.
    </p>

    <div class="selectors-row">
      <!-- Plant -->
      <mat-form-field appearance="outline">
        <mat-label>Plant Number</mat-label>
        <mat-select
          [(value)]="selectedPlant"
          (selectionChange)="onPlantChange($event.value)"
          [disabled]="deleting">
          @for (plant of plants; track plant) {
            <mat-option [value]="plant">{{ plant }}</mat-option>
          }
        </mat-select>
        @if (loading) {
          <mat-spinner matSuffix diameter="18" />
        }
      </mat-form-field>

      <!-- Zone -->
      <mat-form-field appearance="outline">
        <mat-label>Zone</mat-label>
        <mat-select
          [(value)]="selectedZone"
          (selectionChange)="onZoneChange($event.value)"
          [disabled]="!selectedPlant || loading || noDataForPlant || deleting">
          @for (zone of zones; track zone.Id) {
            <mat-option [value]="zone">{{ zone.Name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Serial -->
      <mat-form-field appearance="outline">
        <mat-label>Serial Number</mat-label>
        <mat-select
          [(value)]="selectedSerial"
          (selectionChange)="onSerialChange($event.value)"
          [disabled]="!selectedZone || noDataForZone || deleting">
          @for (serial of serials; track serial.serialNumber) {
            <mat-option [value]="serial">{{ serial.serialNumber }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    @if (noDataForPlant && selectedPlant && !loading) {
      <p class="no-data-msg">No zones found for plant {{ selectedPlant }}.</p>
    }
    @if (noDataForZone && selectedZone && !loading) {
      <p class="no-data-msg">No active inspections found for this zone.</p>
    }

    <div class="action-row">
      <button
        mat-raised-button
        color="warn"
        [disabled]="!selectedSerial || deleting"
        (click)="deleteSerial()">
        @if (deleting) {
          <mat-spinner diameter="18" />
        } @else {
          Delete Inspection
        }
      </button>
    </div>
  </section>
</div>
